import { Activity } from "lucide-react";
import type { ModuleSpec } from "../types";

export const customerEventsSpec: ModuleSpec = {
  id: "customer-events",
  icon: Activity,
  i18n: {
    namespace: "modules",
    titleKey: "customer-events.title",
    descriptionKey: "customer-events.description",
  },
  nav: {
    path: "/customers/events",
    group: "observe",
    order: 30,
    subgroup: "cdp",
  },
  permission: {
    action: "read",
    subject: "cdp",
  },
  meta: {
    status: "active",
    description: "View and analyze customer events",
  },
};
